import h from 'hyperscript';

import type { Content } from '@disy/ui/content';

import './key-value-panel.css';

const COMPONENT_NAME = 'd-key-value-panel';

export interface KeyValuePanelEntry {
  key: string;
  value: Content;
}

export class KeyValuePanel extends HTMLElement {
  readonly #content;

  constructor(content: KeyValuePanelEntry[]) {
    super();
    this.#content = content;
  }

  connectedCallback() {
    this.classList.add(COMPONENT_NAME);
    this.append(
      h(
        'dl',
        this.#content.flatMap(({ key, value }) => [
          h(`dt.${COMPONENT_NAME}--key`, key),
          h(`dd.${COMPONENT_NAME}--value`, value),
        ]),
      ),
    );
  }
}

customElements.define(COMPONENT_NAME, KeyValuePanel);
